import {
  CORE_LOAD_ALL_CONTACT_REQUEST,
  CORE_LOAD_ALL_CONTACT_SUCCESS,
  CORE_LOAD_ALL_CONTACT_FAILURE,

  CORE_LOAD_SEARCH_CONTACT_REQUEST,
  CORE_LOAD_SEARCH_CONTACT_SUCCESS,
  CORE_LOAD_SEARCH_CONTACT_FAILURE,

  CORE_LOAD_CONTACT_REQUEST,
  CORE_LOAD_CONTACT_SUCCESS,
  CORE_LOAD_CONTACT_FAILURE,

  REQUEST_STATE
} from '../types'

const initialState = []
  , initialStateObj = {}
  , requestState = REQUEST_STATE
export default {
  allContact: (state = requestState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALL_CONTACT_REQUEST:
        return requestState
      case CORE_LOAD_ALL_CONTACT_SUCCESS:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload
        } else return []
      case CORE_LOAD_ALL_CONTACT_FAILURE:
        return initialState
      default:
        return state
    }
  },
  searchContact: (state = requestState, action) => {
    switch (action.type) {
      case CORE_LOAD_SEARCH_CONTACT_REQUEST:
        return requestState
      case CORE_LOAD_SEARCH_CONTACT_SUCCESS:
        if (action.payload && Array.isArray(action.payload)) {
          return action.payload
        } else return []
      case CORE_LOAD_SEARCH_CONTACT_FAILURE:
        return initialState
      default:
        return state
    }
  },
  contactInfo: (state = requestState, action) => {
    switch (action.type) {
      case CORE_LOAD_CONTACT_REQUEST:
        return requestState
      case CORE_LOAD_CONTACT_SUCCESS:
        if (action.payload && typeof action.payload === 'object' && !Array.isArray(action.payload)) {
          return action.payload
        } else return {}
      case CORE_LOAD_CONTACT_FAILURE:
        return initialStateObj
      default:
        return state
    }
  },
}



// WEBPACK FOOTER //
// ./src/reducers/reducerContact.js